import { ArrowRight } from "lucide-react";
import { Button } from "./Button";
import { Overline } from "./Reveal";

export const CTASection = ({
  overline = "Get Started",
  heading = "Ready to make better technology decisions?",
  body = "Schedule a Technology Health Assessment and get clear, practical guidance from a team that puts your business outcomes first.",
  primaryLabel = "Schedule a Technology Health Assessment",
  primaryTo = "/technology-health-snapshot#snapshot-form",
  testid = "cta-section",
}) => (
  <section data-testid={testid} className="relative overflow-hidden bg-forest">
    <div className="absolute inset-0 opacity-[0.07]" aria-hidden>
      <svg width="100%" height="100%">
        <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" />
        </pattern>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>
    </div>
    <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 text-center">
      <Overline light>{overline}</Overline>
      <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight">
        {heading}
      </h2>
      <p className="mt-6 text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">{body}</p>
      <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
        <Button to={primaryTo} variant="gold" size="lg" data-testid={`${testid}-primary`}>
          {primaryLabel} <ArrowRight className="h-5 w-5" />
        </Button>
        <Button to="/methodology" variant="ghostLight" size="lg" data-testid={`${testid}-secondary`}>
          See How We Work
        </Button>
      </div>
    </div>
  </section>
);
